import { on } from 'delegated-events'
import LazyLoad from '../common/lazyLoad'

const SELECTORS = Selectors({
  siteHeader: 'site-header',
  project: 'studio-project',
  currentProject: 'studio-project.is-current-project',
  nextProject: 'studio-project.is-next-project'
})

const $siteHeader = document.querySelector(SELECTORS.asClass('siteHeader'))
const $siteTitle = document.querySelector('title')

const fn = {
  init: () => {
    fn.setupNextProject()

    on('click', SELECTORS.asClass('nextProject'), fn.loadNextProject)

    window.addEventListener('popstate', () => {
      window.scrollTo(0, 0)
      window.location.reload()
    })
  },

  setupNextProject: () => {
    const $currentProject = document.querySelector(`article${SELECTORS.asClass('project')}`)

    if ($currentProject) {
      const nextProjectUrl = $currentProject.dataset.nextProject

      if (nextProjectUrl) {
        $currentProject.classList.add('is-fetching-project')

        ajax(nextProjectUrl)
          .get()
          .json(resp => {
            $currentProject.classList.add('is-current-project')
            $currentProject.parentNode.insertAdjacentHTML('beforeend', resp.html)
            $currentProject.classList.remove('is-fetching-project')

            LazyLoad.init()
          })
      }
    }
  },

  loadNextProject: () => {
    const $currentProject = document.querySelector(SELECTORS.asClass('currentProject'))
    const $nextProject = document.querySelector(SELECTORS.asClass('nextProject'))

    window.history.pushState({ path: $nextProject.dataset.url }, $nextProject.dataset.title, $nextProject.dataset.url)
    $siteTitle.textContent = $nextProject.dataset.title

    const transEndEventName = ('WebkitTransition' in document.documentElement.style) ?
      'webkitTransitionEnd' :
      'transitionend'

    $currentProject.classList.add('is-leaving')

    $currentProject.addEventListener(transEndEventName, () => {
      document.body.classList.add('is-loading-project')
      $nextProject.style.transform = `translate3d(0, ${$nextProject.getBoundingClientRect().top}px, 0)`
      $nextProject.classList.add('is-entering')
      window.scrollTo(0, 0)
      $nextProject.style.transform = `translate3d(0, ${$siteHeader.offsetHeight}px, 0)`
      $nextProject.classList.add('is-entering-active')
    }, {
      once: true
    })

    $nextProject.addEventListener(transEndEventName, () => {
      $currentProject.remove()
      document.body.classList.remove('is-loading-project')
      $nextProject.style.transform = null
      $nextProject.classList.remove('is-entering', 'is-entering-active', 'is-next-project')
      $nextProject.classList.add('is-current-project')

      fn.setupNextProject()
    }, {
      once: true
    })
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-studioprojectpage'),
  run: fn.init
}
